import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { RouteComponentProps } from 'react-router'

import { RealWorldDataProgram } from './RealWorldDataProgram'
import { ProgramPage } from './RealWorldDataProgram.model'
import { ClinButton } from '../../components/ClinButton'
import { ClinPageContentFrame } from '../../components/ClinPageContentFrame'
import { ClinText } from '../../components/ClinText'
import useFeatureFlagRedirect from '../../context/featureFlags/FeatureFlagBasedRedirect'

export const RealWorldDataProgramContainer: React.FC<
  RouteComponentProps
> = () => {
  useFeatureFlagRedirect(true)
  const { t } = useTranslation()
  const [content, setContent] = useState<ProgramPage | null>(null)
  const [hasError, setHasError] = useState(false)
  const [attempt, setAttempt] = useState(0)

  useEffect(() => {
    let active = true
    const controller = new AbortController()
    setHasError(false)
    setContent(null)

    axios
      .get<ProgramPage>('/content/real-world-data', {
        signal: controller.signal,
        timeout: 25000
      })
      .then(({ data }) => {
        if (!active) return
        if (
          typeof data?.data?.Title?.iv !== 'string' ||
          typeof data?.data?.Content?.iv !== 'string'
        ) {
          setHasError(true)
          return
        }
        setContent(data)
      })
      .catch(() => {
        if (active) setHasError(true)
      })

    return () => {
      active = false
      controller.abort()
    }
  }, [attempt])

  if (hasError) {
    return (
      <ClinPageContentFrame>
        <div role="alert">
          <ClinText>{t('program_detail:rwd_content_error')}</ClinText>
        </div>
        <ClinButton onClick={() => setAttempt((value) => value + 1)}>
          {t('program_detail:rwd_content_retry')}
        </ClinButton>
      </ClinPageContentFrame>
    )
  }

  return <RealWorldDataProgram content={content} />
}
